import { render, staticRenderFns } from "./EntityEvents.vue?vue&type=template&id=10bc4886&scoped=true"
import script from "./EntityEvents.vue?vue&type=script&lang=js"
export * from "./EntityEvents.vue?vue&type=script&lang=js"
import style0 from "./EntityEvents.vue?vue&type=style&index=0&id=10bc4886&prod&lang=scss&scoped=true"
import style1 from "./EntityEvents.vue?vue&type=style&index=1&id=10bc4886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc4886",
  null
  
)

export default component.exports